module.exports = __webpack_public_path__ + "static/media/14UNEP11.d05c1167.jpg";